// auth-form.jsx
import React, {useState} from 'react';
import Input from "./Input";
import Button from "../Button";
function getServerAddress(){
    return process.env.REACT_APP_API_ENDPOINT;
}
const ManualRegisterForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [isError, setIsError] = useState(false);
    const [isCompletedWithSuccess, setIsCompletedWithSuccess] = useState(false);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const apiEndpoint = getServerAddress()+`api/auth/register`;
            // Envoyer les données au backend
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...formData,
                    timestamp: new Date().toISOString()
                })
            });

            if (response.ok) {
                // Rediriger vers la page de succès
                window.location.href = '/reavie/register';
                setIsCompletedWithSuccess(true) ;
            } else {
                setIsError(true);
            }
        } catch (error) {
            console.error('Erreur:', error);
            alert('Une erreur est survenue. Veuillez réessayer.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="registerForm" >

            {showForm ? (
                <form onSubmit={handleSubmit}>



                        <Input
                            type="text"
                            label="Prénom"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required={true}
                        />



                        <Input
                            type="text"
                            label="Nom"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />



                        <Input
                            type="email"
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />


                    <div className="submit-container">
                        {!isSubmitting && <Button type="submit"
                                                  value="Envoyer"
                                                  disabled={isSubmitting}
                                                  className="g-recaptcha"/>}
                        {isError && <div className="error-message">Erreur détectée pendant la transmission des coordonnées</div>}
                        {isCompletedWithSuccess && <div className="p-badge-success">Transmis avec succès</div>}
                    </div>

                </form>
            ) : (
                <div>
                    <h3>Identifiez-vous avec fournisseurs externes</h3>
                </div>
            )}




        </div>
    );
};

export default ManualRegisterForm;